export default __webpack_public_path__ + "static/media/navic-clock.0109adc9.jpg";